<div class="card">
    <div class="card-header">
        <h5 class="card-title">
            {{'MOBILE_UPDATE.TITLE' | translate }}
        </h5>
    </div>

    <div class="card-body">
        <p class="mt-2 mb-2">{{'MOBILE_UPDATE.TEXT' | translate }}</p>
        <a [href]="storeLink" class="store-logo-link">
            <img [src]="storeLogo" [alt]="'MOBILE_UPDATE.CTA' | translate" class="store-logo" />
        </a>
    </div>
</div>
